import type React from 'react';

import { Flex, ProgressCircle, styled } from '@creditas-ui/react';

const CenterProgress = styled(Flex)`
  position: fixed;
  top: 50%;
  left: 50%;
`;

export const CenterScreenLoading: React.FC = () => (
  <CenterProgress data-testid="spinner">
    <ProgressCircle size="large" />
  </CenterProgress>
);

export const Loading = () => (
  <ProgressCircle size="large" data-testid="loading" />
);
